const ONNARankTypes = {
    FETCH_START:    '[ONNA][RANK] FETCH START',
    FETCH_SUCCESS:  '[ONNA][RANK] FETCH SUCCESS'
};

export default ONNARankTypes;